import _ from 'lodash'

let domHelper = {
  getWinWidth () {
    if (typeof (window.innerWidth) === 'number') {
      return window.innerWidth
    } else if (document.documentElement && (document.documentElement.clientWidth)) {
      return document.documentElement.clientWidth
    } else if (document.body && (document.body.clientWidth)) {
      return document.body.clientWidth
    }
  },
  getWinHeight () {
    if (typeof (window.innerHeight) === 'number') {
      return window.innerHeight
    } else if (document.documentElement && (document.documentElement.clientHeight)) {
      return document.documentElement.clientHeight
    } else if (document.body && (document.body.clientHeight)) {
      return document.body.clientHeight
    }
  },
  getScrollTop () {
    return window.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop
  },
  getScrollLeft () {
    return window.pageXOffset || (document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft
  },
  getBodyWidth () {
    return document.body.scrollWidth
  },
  getBodyHeight () {
    return document.body.scrollHeight
  },
  getOffset (el) {
    let top = 0
    let left = 0
    let right = 0
    let bottom = 0
    let width = 0
    let height = 0
    if (el.getBoundingClientRect) {
      let xy = el.getBoundingClientRect()
      let fixIEClientTop = 0
      let fixIEScrollTop = 0
      let fixIEClientLeft = 0
      let fixIEScrollLeft = 0
      if (document.documentElement) {
        fixIEClientTop = document.documentElement.clientTop
        fixIEScrollTop = document.documentElement.scrollTop
        fixIEClientLeft = document.documentElement.clientLeft
        fixIEScrollLeft = document.documentElement.scrollLeft
      }
      top = xy.top - fixIEClientTop + fixIEScrollTop
      left = xy.left - fixIEClientLeft + fixIEScrollLeft
      right = xy.right
      bottom = xy.bottom
      width = xy.width || right - left
      height = xy.height || bottom - top
    } else {
      do {
        left += el.offsetLeft - el.scrollLeft
        top += el.offsetTop - el.scrollTop
        el = el.offsetParent
      } while (el)
      width = el.offsetWidth
      height = el.offsetHeight
      right = left + width
      bottom = top + height
    }
    return {
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      width: width,
      height: height
    }
  },
  getElSize (el) {
    let width = 0
    let height = 0
    if (el) {
      if (el.getBoundingClientRect) {
        let rect = el.getBoundingClientRect()
        width = rect.width || rect.right - rect.left
        height = rect.height || rect.bottom - rect.top
      } else {
        width = parseFloat(el.offsetWidth)
        height = parseFloat(el.offsetHeight)
      }
    }
    return {width: width, height: height}
  },
  getRealElSize (el) {
    let res = this.getStyle(el, ['width', 'height'])
    res['width'] = parseFloat(res.width) || 0
    res['height'] = parseFloat(res.height) || 0
    return res
  },
  getOuterElSize (el) {
    let res = this.getStyle(el, [
      'width', 'height', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
      'padding-top', 'padding-right', 'padding-bottom', 'padding-left'
    ])
    res['width'] = (parseFloat(res.width) || 0)
    res['height'] = (parseFloat(res.height) || 0)
    let tmpSize = this.getElSize(el)
    if (tmpSize.width - res['width'] >= 1) {
      res['width'] += (parseFloat(res['padding-left']) || 0) + (parseFloat(res['padding-right']) || 0)
    }
    if (tmpSize.height - res['height'] >= 1) {
      res['height'] += (parseFloat(res['padding-top']) || 0) + (parseFloat(res['padding-bottom']) || 0)
    }
    res['width'] += (parseFloat(res['margin-left']) || 0) + (parseFloat(res['margin-right']) || 0)
    res['height'] += (parseFloat(res['margin-top']) || 0) + (parseFloat(res['margin-bottom']) || 0)
    res['marginWidth'] = (parseFloat(res['margin-left']) || 0) + (parseFloat(res['margin-right']) || 0)
    res['marginHeight'] = (parseFloat(res['margin-top']) || 0) + (parseFloat(res['margin-bottom']) || 0)
    res['paddingHeight'] = (parseFloat(res['padding-top']) || 0) + (parseFloat(res['padding-bottom']) || 0)
    res['paddingWidth'] = (parseFloat(res['padding-left']) || 0) + (parseFloat(res['padding-right']) || 0)
    return res
  },
  getStyle (el, attrs = []) {
    let styles = {}
    if (el) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        let computedStyles = document.defaultView.getComputedStyle(el, null)
        if (attrs.length > 0) {
          _.each(attrs, (value) => {
            styles[value] = computedStyles.getPropertyValue(value)
          })
        } else {
          styles = computedStyles
        }
      } else if (window.getComputedStyle) {
        let computedStyles = window.getComputedStyle(el, null)
        if (attrs.length > 0) {
          _.each(attrs, (value) => {
            styles[value] = computedStyles.getPropertyValue(value)
          })
        } else {
          styles = computedStyles
        }
      } else if (el.currentStyle) {
        let currentStyle = el.currentStyle
        if (attrs.length > 0) {
          _.each(attrs, (value) => {
            styles[value] = currentStyle[value]
          })
        } else {
          styles = currentStyle
        }
      }
    }
    return styles
  },
  setDocTitle (title, img = '') {
    if (title === undefined || window.document.title === title) {
      return
    }
    document.title = title
    let mobile = navigator.userAgent.toLowerCase()
    if (/iphone|ipad|ipod/.test(mobile)) {
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      let iframeCallback = function () {
        setTimeout(function () {
          iframe.removeEventListener('load', iframeCallback)
          document.body.removeChild(iframe)
        }, 0)
      }
      iframe.addEventListener('load', iframeCallback)
      document.body.appendChild(iframe)
    }
  }
}

export default domHelper



// WEBPACK FOOTER //
// ./src/assets/js/helper/dom.js